var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loader',{attrs:{"loaded":_vm.departmentLoaded,"marginTop":25}}),(_vm.$vuetify.breakpoint.xsOnly)?_c('XsDepartment',{attrs:{"department":_vm.department}}):_c('Department',{attrs:{"department":_vm.department}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }